<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xiii">ACKNOWLEDGMENTS</a></p><a id="page_xiii">
<p class="noindentb">O<span class="small">UR HEARTFELT THANKS</span> go to the following persons for their invaluable assistance throughout the writing of this book:</p>
<p class="indentb">Ivane Béatrice Bellocq, Sylvie Beltrando, Philippe Bonnet, Jean-Yves Bosseur, Florence Bourdon, Frédérique Cambreling, Gilles Carré, Bernard Cavanna, Bertrand Chavarrià-Aldrete, Isabelle Daups, Rhodri Davies, Félicité De Lalande, François Decarsin, Anne Dessus, Bernard de Vienne, Mary Fata, Martine Flaissier, Marie-Hélène Fournier, Jakez François, Vanessa Gerkens, Bruno Giner, Bastien Golliard, Béatrice Guillermin, June Han, Ursula Holliger, Sonja Inglefield, Philippe Leroux, Anja Linder, Zad Moultaka, Xenia Narati, Jean-Pierre Néré, Ghislaine Petit-Volta, Michèle Reverdy, François Rossé, Christophe Saunière, Philippe Schoeller, Michel Sendrez, Kazuko Gao Shinozaki, Ayako Shinozaki, Isabelle Spiers, Ernestine Stoop, Brigitte Sylvestre, Christophe Truant, Angelica Vazquez, Claire Vial, Ann Yeung</p>
<p class="indent"><i>Laure Marcel-Berlioz, Corinne Monceau, and all the CDMC team</i></p>
<p class="indent"><i>Germaine Tissier-Grandpierre Foundation</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Acknowledgement.vue?5f4d2603